export const standardCompanyDeclaration = `
  <div>
    <ul class="m-0">
      <li>
        I apply for the registration of a company on the basis of the information in this form
        and any attachments. I have the necessary written consents and agreements referred to in this
        application concerning the members and officeholders and I shall give the consents and agreements to
        the company after the company becomes registered. The information provided in this application and in
        any annexures is true and correct at the time of signing.
      </li>

      <li>
        The information provided to ASIC in this form may include personal information. Please refer to
        our privacy policy (<a target="_blank" href="//www.asic.gov.au/privacy">www.asic.gov.au/privacy</a>) for more infromation about how we handle your personal information,
        your rights to seek access to and correct personal information, and to complain about breaches of privacy.
      </li>

      <li>
        I declare that I own, or am registering the company for the owner(s) of the identical business name(s),
        the registration details of which are listed
      </li>
    </ul>
  </div>
`;

export const specialPurposeCompanyDeclaration = `
  <div>
    <ul class="m-0">
      <li>
        I apply for the registration of a company on the basis of the information in this form and any attachments.
        I have the necessary written consents and agreements referred to in this application concerning the members
        and officeholders and I shall give the consents and agreement to the company after the company becomes registered.
         The information provided in this application and any annexures is true and correct at the time of signing.
      </li>

      <li>
        I declare that this company is a special purpose company as defined under Regulation 3 of the Corporations (Fees) Regulations 2003.
      </li>

      <li>
        The information provided to ASIC in this form may include personal information.
        Please refer to our privacy policy (<a target="_blank" href="//www.asic.gov.au/privacy">www.asic.gov.au/privacy</a>) for more information
        about how we handle your personal information, your rights to seek access to and correct personal information,
        and to complain about breaches of privacy.
      </li>

       <li>
        I declare that I own, or am registering the company for the owner(s) of the identical business name(s),
        the registration details of which are listed
      </li>
    </ul>
  </div>
`;

export const companyRegistrationDeclarationLabel = 'By completing this form, I assent to the following declarations:';
